import { styled } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";

const StyledAppBar = styled(MuiAppBar)<{
    position?: "fixed" | "absolute" | "sticky" | "static" | "relative";
    elevation?: number;
}>(({ theme, position = "static", elevation }) => ({
    ...(position === "fixed" && {
        zIndex: theme.zIndex.appBar,
    }),
    ...(elevation !== undefined && {
        boxShadow: theme.shadows[elevation],
    }),
    backgroundColor: "rgb(216, 220, 227)",
}));

/**
 * Props for the AppBar component.
 *
 * @property {"fixed"|"absolute"|"sticky"|"static"|"relative"} [position] - The positioning type of the AppBar. Defaults to "static".
 * @property {number} [elevation] - The elevation (shadow depth) of the AppBar.
 * @property {React.ReactNode} children - The content to render inside the AppBar.
 * @property {string} [className] - Additional class names for the AppBar.
 */
export interface AppBarProps {
    position?: "fixed" | "absolute" | "sticky" | "static" | "relative";
    elevation?: number;
    children: React.ReactNode;
    className?: string;
}

/**
 * AppBar
 *
 * A styled wrapper around MUI's AppBar, providing consistent background color and optional elevation.
 * Accepts children for flexible content placement.
 *
 * @param {AppBarProps} props - The props for the AppBar component.
 * @returns {JSX.Element} The rendered AppBar component.
 */
export const AppBar: React.FC<AppBarProps> = ({
    position = "static",
    elevation,
    children,
    className,
}) => {
    return (
        <StyledAppBar
            position={position}
            elevation={elevation}
            className={className}
        >
            {children}
        </StyledAppBar>
    );
};
